<template lang="pug">
  .container
  </template>

<script>
export default {
  name: "DetalhesMonitoramento",
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    monitoramento: {
      type: Object,
      required: true,
    },
  },
  async created() {
  },
  methods: {
    visualizarDetalhesMonitoramento(id) {
      this.abrirModalDetalhesMonitoramento = true;
    },
    fecharModalDetalhesMonitoramento() {
      this.abrirModalDetalhesMonitoramento = false;
    }
  },
  computed: {
  }
};
</script>

<style scoped lang="scss">
@import '@/styles/variaveis.scss';

</style>